// filepath: /Users/danmorris/Documents/dev/sas-dev-fe/src/HealthCheck.js
import React from "react";

const HealthCheck = () => {
  return <div>Success - All good</div>;
};

export default HealthCheck;
